import AuthGuard from "./auth-guard";
import AuthGuardUser from "./auth-guard-user";
import LoginToDash from "./login-to-dash";

/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: "/login",
    view: "Login",
    meta: { isFrontend: false },
    beforeEnter: LoginToDash,
  },
  {
    path: "/login/:redirect",
    view: "Login",
    meta: { isFrontend: false },
    beforeEnter: LoginToDash,
  },
  {
    path: "/",
    view: "Home",
    meta: { isFrontend: true },
  },
  {
    path: "/thanksForFeedback/:emailFeedbackType/:supplierName",
    view: "Home",
    meta: { isFrontend: true },
  },
  {
    path: "/about",
    view: "About",
    meta: { isFrontend: true },
  },
  {
    path: "/ourTeam",
    view: "OurTeam",
    meta: { isFrontend: true },
  },
  // {
  //   path: "/impactBoxes",
  //   view: "GiftBox",
  //   meta: { isFrontend: true },
  // },
  {
    path: "/join",
    view: "Join",
    meta: { isFrontend: true },
  },
  {
    path: "/SupplierJoinOld",
    view: "SupplierJoinOld",
    meta: { isFrontend: true },
  },
  {
    path: "/GoodCauseJoin",
    view: "GoodCauseJoin",
    meta: { isFrontend: true },
  },
  {
    path: "/ImpactBusinessJoin",
    view: "ImpactCustomerJoin",
    meta: { isFrontend: true },
  },
  {
    path: "/contact",
    view: "Contact",
    meta: { isFrontend: true },
  },
  {
    path: "/SupplierJoin",
    view: "SupplierJoin",
    meta: { isFrontend: true },
  },
  {
    path: "/GoodCauses",
    view: "GoodCausePublic",
    meta: { isFrontend: true },
  },
  {
    path: "/GoodCauses/:id",
    view: "GoodCauseProfile",
    meta: { isFrontend: true },
  },

  {
    path: "/searchResults",
    view: "SearchResults",
    name: "SearchResults",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/service/:service",
    name: "SearchResultsService",
    view: "SearchResults",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/category/:category",
    view: "SearchResults",
    name: "SearchResultsCategory",
    meta: { isFrontend: true },
  },

  //Breadcrumb System
  {
    path: "/searchResults/:servicing",
    name: "SearchResultsServiceFiltered",
    view: "SearchResults",
    meta: { isFrontend: true },
  },
  //Breadcrumb route when handling searches
  {
    path: "/searchResults/service/:service/:servicing/:categoryId",
    name: "SearchResultsSearchWithBreadcrumb",
    view: "SearchResults",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/service/:service/:servicing",
    name: "SearchResultsSearchWithBreadcrumb",
    view: "SearchResults",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/service/:service/:servicing/business/:id",
    name: "BusinessProfileSearchWIthBreadcrumbServicing",
    view: "BusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/service/:service/:servicing/:categoryId/business/:id",
    name: "BusinessProfileSearchWithBreadcrumb",
    view: "BusinessProfile",
    meta: { isFrontend: true },
  },
  //end of breadcrumb handling searches
  {
    path: "/searchResults/:servicing/:categoryId",
    name: "SearchResultsServiceCatFiltered",
    view: "SearchResults",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/:servicing/business/:id",
    name: "BusinessProfileServiceFiltered",
    view: "BusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/searchResults/:servicing/:categoryId/business/:id",
    name: "BusinessProfileServiceCatFiltered",
    view: "BusinessProfile",
    meta: { isFrontend: true },
  },

  //End Of Breadcrumb System
  {
    path: "/business/:id",
    name: "BusinessProfileID",
    view: "BusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/impactBusinessProfile/:keyword",
    name: "ImpactBusinessProfileKeyword",
    view: "ImpactBusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/ImpactBuyer/:keyword",
    name: "ImpactBusinessProfileKeywordImpactBuyer",
    view: "ImpactBusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/impactbuyer/:keyword",
    name: "ImpactBusinessProfileKeywordLowercase",
    view: "ImpactBusinessProfile",
    meta: { isFrontend: true },
  },
  {
    path: "/EntityLink/:linkKey",
    name: "EntityLink",
    view: "BusinessCustomLink",
    meta: { isFrontend: true },
  },
  {
    path: "/EntityLink/:linkKey/:leadID",
    name: "EntityLinkHighlightedCard",
    view: "BusinessCustomLink",
    meta: { isFrontend: true },
  },
  {
    path: "/ProspectingBuyers/:linkKey",
    name: "ProspectingBuyers",
    view: "GoodCauseCustomLink",
    meta: { isFrontend: true },
  },
  {
    path: "/impactBusiness",
    view: "ImpactBusiness",
    meta: { isFrontend: true },
  },
  {
    path: "/buy/:keyword",
    view: "BusinessProfile",
    meta: { isFrontend: true },
    name: "keywordNavigation",
  },
  {
    path: "/use/:keyword",
    view: "BusinessProfile",
    meta: { isFrontend: true },
    name: "keywordNavigationUse",
  },
  {
    path: "/AboutUpstream",
    view: "AboutUpstream",
    name: "AboutUpstream",
    meta: { isFrontend: true },
  },
  {
    path: "/coffee",
    view: "BusinessProfile",
    name: "BusinessProfileCoffee",
    meta: { isFrontend: true },
  },
  {
    path: "/admin/dashboard",
    view: "Dashboard",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/orders",
    view: "Orders",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/businesses",
    name: "Businesses",
    view: "Businesses",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/businesses/:id/:testimonialID",
    name: "Testimonial-Businesses",
    view: "Businesses",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/businesses/:id",
    name: "BusinessesAdminProfile",
    view: "Businesses",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/users",
    name: "Users",
    view: "Users",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/userProfile",
    name: "UserProfile",
    view: "UserProfile",
    meta: { isFrontend: true },
    beforeEnter: AuthGuardUser,
  },
  {
    path: "/admin/GoodCauses",
    name: "GoodCauses",
    view: "GoodCauses",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/ImpactBusinessAdmin",
    name: "ImpactBusinessAdmin",
    view: "ImpactBusinessAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/ImpactBusinessAdmin/:id",
    name: "ImpactBusinessAdminProfile",
    view: "ImpactBusinessAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/featuredListings",
    name: "FeaturedListings",
    view: "FeaturedListings",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/customers",
    view: "Customers",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/categories",
    view: "CategoryAdministration",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/actionCenter",
    view: "AdminNewJob",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/searchResults_api",
    view: "SearchResults_api",
    name: "SearchResults_api",
    meta: { isFrontend: true },
  },
  {
    path: "/admin/affiliateLinkClicks",
    view: "AffiliateLinkClicks",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/testimonials",
    view: "Testimonials",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/salesEnquiry",
    name: "SalesEnquiryAdmin",
    view: "SalesEnquiryAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/salesEnquiry/:id",
    name: "SalesEnquiryAdminView",
    view: "SalesEnquiryAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  // {
  //   path: "/admin/myEnquiries",
  //   name: "SalesEnquiryAdminBuyer",
  //   view: "SalesEnquiryAdmin",
  //   meta: { isFrontend: false },
  //   beforeEnter: AuthGuard,
  // },
  // {
  //   path: "/admin/myEnquiries/:id",
  //   name: "SalesEnquiryAdminBuyerView",
  //   view: "SalesEnquiryAdmin",
  //   meta: { isFrontend: false },
  //   beforeEnter: AuthGuard,
  // },
  {
    path: "/admin/gcEnquiries",
    name: "SalesEnquiryAdminGC",
    view: "SalesEnquiryAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/leads",
    name: "LeadsAdmin",
    view: "LeadsAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/leads/:id",
    name: "LeadsAdminView",

    view: "LeadsAdmin",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/salesTrackingStats",
    view: "SalesTrackingStats",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
  {
    path: "/admin/yourProfile",
    view: "entityAdminProfile",
    meta: { isFrontend: false },
    beforeEnter: AuthGuard,
  },
];
